import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class MapsEditIndexRoute extends Route {
  @service router;
  @service abilities;

  async beforeModel() {
    if (this.abilities.cannot('manage-floor maps')) {
      this.router.transitionTo('unauthorized');
    }

    const { areaMap } = this.modelFor('spaces.maps');
    const firstMapFloor = (await areaMap.mapFloors).sortBy('ordinality').slice()[0];
    if (firstMapFloor) {
      this.router.transitionTo('spaces.maps.edit.show', {
        queryParams: { floor_id: firstMapFloor.id },
      });
    }
  }

  model() {
    const { areaMap } = this.modelFor('spaces.maps');
    return {
      areaMap,
    };
  }
}
